import React, { useState, useEffect } from "react";
import "../styles/Services.css";

import LD1 from "../assets/ld1.jpeg";
import LD2 from "../assets/ld2.jpeg";
import LD3 from "../assets/ld3.jpeg";
import LD4 from "../assets/ld4.jpeg";
import LD5 from "../assets/ld5.jpeg";
import LD6 from "../assets/ld6.jpeg";
import LD7 from "../assets/ld7.jpeg";
import LD8 from "../assets/ld8.jpeg";

import EarlyImg from "../assets/Early_Industry_education_programme.jpeg";
import GCCImg from "../assets/Global_Capability_Centre.jpeg";
import ConsultImg from "../assets/Consultancy_Technical_Staffing.jpeg";
import LDImg from "../assets/Learning_and_Development.jpeg";

const Services = () => {
  const [activeModal, setActiveModal] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  const ldImages = [LD1, LD2, LD3, LD4, LD5, LD6, LD7, LD8];

  const openModal = (modal) => setActiveModal(modal);
  const closeModal = () => setActiveModal(null);

  useEffect(() => {
    if (activeModal === "ld") {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % ldImages.length);
      }, 4000);
      return () => clearInterval(interval);
    }
  }, [activeModal, ldImages.length]);

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % ldImages.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + ldImages.length) % ldImages.length);

  return (
    <section className="services fade-in" id="services">
      <h2 data-aos="fade-up">Our Services</h2>

      <div className="services-grid">
        {/* Early Education */}
        <div className="service-column" data-aos="fade-right">
          <img src={EarlyImg} alt="Early Education" className="service-img" />
          <h3>Early Industry Education Programme – Shaping Future Learning</h3>
          <p>
            Our Early Education Industry Programme helps graduates gain hands-on,
            industry experience while earning their degree.
          </p>
          <div className="explore-btn-container">
            <button className="explore-btn" onClick={() => openModal("early")}>
              Explore More →
            </button>
          </div>
        </div>

        {/* GCC */}
        <div className="service-column" data-aos="zoom-in">
          <img src={GCCImg} alt="GCC Service" className="service-img" />
          <h3>Global Capability Center (GCC) – Build & Scale from India</h3>
          <p>
            Our Global Capability Center (GCC) services enable companies to set up and
            manage global operations in India...
          </p>
          <div className="explore-btn-container">
            <button className="explore-btn" onClick={() => openModal("gcc")}>
              Explore More →
            </button>
          </div>
        </div>

        {/* Consultancy */}
        <div className="service-column" data-aos="fade-left">
          <img src={ConsultImg} alt="Consultancy" className="service-img" />
          <h3>Consultancy (Technical & Staffing) – Expertise That Delivers</h3>
          <p>
            Our consulting services provide organizations with the right technical
            expertise and staffing solutions...
          </p>
          <div className="explore-btn-container">
            <button className="explore-btn" onClick={() => openModal("consultancy")}>
              Explore More →
            </button>
          </div>
        </div>

        {/* L&D */}
        <div className="service-column" data-aos="flip-up">
          <img src={LDImg} alt="Learning and Development" className="service-img" />
          <h3>Learning & Development (L&D) – Empowering Talent for Tomorrow</h3>
          <p>
            We design customized learning & development programs to upskill workforces
            and prepare them for the future...
          </p>
          <div className="explore-btn-container">
            <button className="explore-btn" onClick={() => openModal("ld")}>
              Explore More →
            </button>
          </div>
        </div>
      </div>

      {/* === MODALS === */}
      {activeModal === "early" && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-btn" onClick={closeModal}>×</button>
            <h2>Early Education Industry Programme</h2>
            <p>
              Our Early Education Industry Programme bridges the gap between classroom
              learning and practical exposure. Students gain hands-on experience,
              mentorship, and job-readiness skills before graduation.
            </p>
            <ul>
              <li>Live projects under expert guidance</li>
              <li>Soft skills and professional grooming</li>
              <li>Industry workshops and internships</li>
            </ul>
          </div>
        </div>
      )}

      {activeModal === "gcc" && (
        <div className="modal-overlay">
          <div className="modal-content gcc-modal">
            <button className="close-btn" onClick={closeModal}>×</button>
            <h2>Global Capability Center</h2>
            <div className="gcc-grid">
              <div>
                <h3>Venturebiz Consulting</h3>
                <h4>Application Services</h4>
                <p>ADMS</p>
                <p>Intelligent Automation</p>
                <p>Testing Services</p>
                <p>Performance Engineering</p>

                <h4>Cloud & Infrastructure Services</h4>
                <p>Cloud Consulting</p>

                <h4>Engineering Services</h4>
                <h4>Network Services</h4>
              </div>
              <div>
                <h3>Data Analytics</h3>
                <h3>Artificial Intelligence</h3>
                <h4>Digital Enterprise Applications</h4>
                <p>Microsoft Business Applications</p>
                <p>Enterprise Digital Solutions</p>
                <p>SAP</p>
                <p>Service Now</p>
                {/* <p>Oracle</p> */}
                {/*<p>Salesforce</p> */}
                <p>Pega</p>
              </div>
              <div>
                <h3>Business Process Services</h3>
                <h4>Experience Services</h4>
                <h4>Next Gen Services</h4>
                <p>Cyber Security</p>
                <p>Blockchain</p>
                <p>Metaverse</p>
                <h4>Sustainability Services</h4>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeModal === "consultancy" && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-btn" onClick={closeModal}>×</button>
            <h2>Consultancy (Technical & Staffing)</h2>
            <p>
              Our consultancy and staffing solutions connect businesses with top-tier
              professionals to drive operational success.
            </p>
            <ul>
              <li>Tailored staffing for IT and business roles</li>
              <li>Project-based technical consultation</li>
              <li>End-to-end resource management</li>
            </ul>
          </div>
        </div>
      )}

      {activeModal === "ld" && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-btn" onClick={closeModal}>×</button>
            <h2>Learning & Development (L&D)</h2>
            <div className="carousel-container">
              <div
                className="carousel-slide"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {ldImages.map((img, index) => (
                  <img key={index} src={img} alt={`L&D ${index + 1}`} />
                ))}
              </div>
              <button className="carousel-btn prev" onClick={prevSlide}>‹</button>
              <button className="carousel-btn next" onClick={nextSlide}>›</button>
            </div>
            <p>
              Our organization builds strong leadership pipelines, upskills employees 
              with industry-relevant skills, and improves productivity 
              through structured training programs.
            </p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Services; 